import {
  journeyAnalytics,
  type StartedEvent,
} from "@src/features/analytics/journeyAnalytics"

export type ConfidentialAccountMoveJourney = Extract<
  StartedEvent,
  { journey: { flow: "confidential_account_move" } }
>

export type ConfidentialAccountMoveAnalytics = Readonly<{
  journey: ConfidentialAccountMoveJourney
  intentHash: string
}>

export function startConfidentialAccountMoveJourney(
  direction: ConfidentialAccountMoveJourney["direction"]
): ConfidentialAccountMoveJourney {
  const event = {
    journey: {
      journeyId: journeyAnalytics.newId(),
      flow: "confidential_account_move",
      privacy: "public",
      valuation: null,
    },
    surface: "transfer",
    direction,
  } satisfies ConfidentialAccountMoveJourney

  journeyAnalytics.started(event)
  return event
}

export function submitConfidentialAccountMoveJourney({
  journey,
  intentHash,
}: ConfidentialAccountMoveAnalytics): void {
  journeyAnalytics.submitted({
    ...journey,
    operation: { namespace: "intent", key: intentHash },
  })
}

export function completeConfidentialAccountMoveJourney({
  journey,
  intentHash,
}: ConfidentialAccountMoveAnalytics): void {
  journeyAnalytics.completed({
    ...journey,
    operation: { namespace: "intent", key: intentHash },
  })
}
